module.exports = __webpack_public_path__ + "img/圆9排10列.fc519e15.png";